<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="NewFeedChannel"
    title="New Feed Channel"
    submit-name="Create"
    full-height
    :submit-disabled="!channels"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <template v-if="currentLandscape">
      <lm-actor-select
        ref="actorSelect"
        :selected-actor="selectedActor"
        check-rights
      >
        Add feed to:
      </lm-actor-select>
      <lm-channel-list
        ref="channelList"
        :channels="channels"
        @channelSelected="onChannelSelected"
      />
      <lm-input
        ref="inputTitle"
        label="Title"
        :maxlength="0"
        @submit="submitFromInput()"
      />
      <lm-textarea
        ref="inputDescription"
        label="Description (optional)"
        :rows="2"
        :allow-breakline="false"
        @submit="submitFromInput()"
      />
      <lm-tags-selector
        ref="tagSelector"
        class="mb-16"
        :options="currentLandscape.tags"
      />
    </template>
  </form-modal>
</template>

<script type="text/babel">
import LmActorSelect from '@/components/form/LmActorSelect'
import {mapGetters} from 'vuex'
import {Events, Modal, FeedSources} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import FormModal from '@/components/modals/FormModal'
import LmInput from '@/components/form/LmInput.vue'
import FormHelper from '@/components/form/formHelper'
import LmTextarea from '@/components/form/LmTextarea.vue'
import LmTagsSelector from '@/components/form/LmTagsSelector'
import LmChannelList from '@/components/form/LmChannelList'

export default {
  name: 'ModalNewFeedChannel',
  components: {
    LmActorSelect,
    LmChannelList,
    LmTextarea,
    LmTagsSelector,
    FormModal,
    LmInput
  },
  data() {
    return {
      Events,
      modalName: Modal.NEW_FEED_CHANNEL,
      modalRef: null,
      inputs: null,
      tags: []
    }
  },
  computed: {
    ...mapGetters(['selectedActor', 'currentLandscape', 'channels'])
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.inputs = [
      this.$refs.actorSelect,
      this.$refs.channelList,
      this.$refs.inputTitle,
      this.$refs.inputDescription,
      this.$refs.tagSelector
    ]
    this.$store.dispatch('loadChannels')
  },
  methods: {
    onChannelSelected(channel) {
      this.$refs.inputTitle.reset()
      this.$refs.inputTitle.setData(channel.title)
      this.$refs.inputDescription.reset()
      this.$refs.inputDescription.setData(channel.description)
    },
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      if (FormHelper.validate(this.inputs)) {
        let payload = {
          actorId: this.$refs.actorSelect.data,
          type: FeedSources.CHANNEL,
          source: this.$refs.channelList.data,
          title: this.$refs.inputTitle.data,
          description: this.$refs.inputDescription.data,
          tags: this.$refs.tagSelector.data
        }
        this.$store
          .dispatch('createSource', payload)
          .then(() => this.modalRef.submitSuccess())
          .catch(error => {
            this.showUrlError()
            this.modalRef.submitFails(error.devMessage)
          })
      } else {
        this.modalRef.submitFails()
      }
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        EventHub.emit(Events.SHOW_SNACKBAR, 'New Channel Source created')
      }
    }
  }
}
</script>
